/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { parse as parseQuery, stringify as stringifyQuery } from 'query-string';
import React from 'react';
import { useLocation } from 'react-router';

import Link from '../partials/Link';

// import Alphabet from './Alphabet';
import styles from '../../../styles/filters/link.module.scss';

const propTypes = {
    filter: PropTypes.shape({
        url: PropTypes.string,
        label: PropTypes.string,
        query: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    }),
    params: PropTypes.arrayOf(PropTypes.string),
    className: PropTypes.string,
};

const defaultProps = {
    filter: null,
    params: ['search', 'edition'],
    className: null,
};

const LinkFilter = ({ filter, params, className }) => {
    const { search, pathname } = useLocation();
    const { url = null, label = null, query, external } = filter || {};

    let filtered = null;
    if (params !== null) {
        const parsed = parseQuery(search);
        filtered = Object.keys(parsed)
            .filter((key) => params.includes(key))
            .reduce((obj, key) => {
                if (parsed[key]) {
                    obj[key] = parsed[key]; // eslint-disable-line
                }
                return obj;
            }, {});
    }

    const urlParams = stringifyQuery({ ...filtered, ...query });

    if (url === null || !label) {
        return null;
    }

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.active]: pathname === url,
                    [className]: className !== null,
                },
            ])}
        >
            {external ? (
                <a
                    href={`${url}${urlParams !== null ? `?${urlParams}` : ''}`}
                    className={classNames([styles.link, styles.external])}
                    target="_blank"
                    rel="noreferrer"
                >
                    {label}
                </a>
            ) : (
                <Link
                    href={`${url}${urlParams !== null ? `?${urlParams}` : ''}`}
                    className={styles.link}
                >
                    {label}
                </Link>
            )}
        </div>
    );
};

LinkFilter.propTypes = propTypes;
LinkFilter.defaultProps = defaultProps;

export default LinkFilter;
